import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const CardType = ({ isSelected, options, isLoading, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Card Type</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        id={'battlecards-filters-card-type'}
                        isMulti
                        options={options}
                        isLoading={isLoading}
                    />
                )}
                name={'cardType'}
                control={control}
            />
        </div>
    ) : null;
};
